import { StytchProvider as StytchProviderBase, useStytch as useStytchBase } from "@stytch/react";
import { createStytchHeadlessClient } from "@stytch/react/headless";
import { useCallback } from "react";
import { AuthenticateMethod } from "@medbillai/generated-graphql-types";
import type { OAuthProviderType } from "@medbillai/ui";
import { analyticsService } from "../../lib/analytics/analytics";
import { useSignUpOnboardingStore } from "../../lib/sign-up-onboarding/signUpOnboardingStore";
import { userSegmentationStorage } from "../../lib/storage/instances";
export const StytchProvider = StytchProviderBase;
export const useStytch = useStytchBase;
export const StytchClient = createStytchHeadlessClient;

// Custom hook for web OAuth that uses redirects
export const useStartOAuth = (authRedirectUri: (method: AuthenticateMethod) => string) => {
  const stytch = useStytch();
  const startOAuth = useCallback(async (provider: OAuthProviderType) => {
    // Get snapshot of user segmentation data to set in storage.
    // Don't need to subscribe to the store because we're just storing it once.
    const userSegmentationData = useSignUpOnboardingStore.getState().userSegmentationData;
    // Store the user segmentation data in session storage, since it doesn't
    // persist through the OAuth flow.
    if (userSegmentationData) {
      await userSegmentationStorage.set("userSegmentationData", JSON.stringify(userSegmentationData));
    }

    // Stytch validates redirect URLs exact-match (incl. query params) —
    // nothing custom may ride this URL; the invite token is stashed in auth
    // state instead.
    const redirectUrl = authRedirectUri(AuthenticateMethod.OAUTH);
    analyticsService.trackEvent("SubmitLogin", {
      method: "OAUTH"
    });
    if (provider === "APPLE") {
      await stytch.oauth.apple.start({
        login_redirect_url: redirectUrl,
        signup_redirect_url: redirectUrl
      });
    } else if (provider === "GOOGLE") {
      await stytch.oauth.google.start({
        login_redirect_url: redirectUrl,
        signup_redirect_url: redirectUrl
      });
    } else {
      throw new Error("Unsupported OAuth provider");
    }
  }, [stytch, authRedirectUri]);
  return {
    startOAuth
  };
};